import { ENDPOINTS } from '@/configs/endpoints';
import { ChartModelsApi, ChartModelsSchema } from '@/entities/ChartModelOption';
import { FieldSelectStore, FieldSelectStoreOptions } from '@/stores/local/shared/form/FieldSelectStore';
import { OptionEntity } from '@/types/OptionEntity';
import call from '@/utils/api';
import type { BaseResponse } from '@/utils/api/types';
import { schemeParse } from '@/utils/schemeParse';

type ChartModelSelectStoreOptions = Omit<FieldSelectStoreOptions<OptionEntity>, 'getOptions'>;
type GetOptionsParams = Parameters<FieldSelectStoreOptions<OptionEntity>['getOptions']>[0];

export class ChartModelSelectStore extends FieldSelectStore<OptionEntity> {
  constructor(options?: ChartModelSelectStoreOptions) {
    super({
      ...options,
      getOptions: async (params: GetOptionsParams): Promise<BaseResponse<{ items: OptionEntity[]; total: number }>> => {
        const { offset, limit, search } = params;
        const response = await this._fetchChartModelOptions({ offset, limit, search });

        if (response.isError) {
          return {
            isError: true,
            error: response.error,
          };
        }

        const parsed = schemeParse(ChartModelsSchema, response.data.items);

        if (parsed.error) {
          return {
            isError: false,
            data: {
              items: [],
              total: 0,
            },
          };
        }

        return {
          isError: false,
          data: {
            items: parsed.data,
            total: response.data.total,
          },
        };
      },
    });
  }

  private async _fetchChartModelOptions(params: { offset: number; limit: number; search: string }) {
    return call<{ items: ChartModelsApi; total: number }>({
      endpoint: ENDPOINTS.chartSessions.chartModels,
      data: { ...params },
    });
  }

  destroy(): void {
    super.destroy();
  }
}
